
/** メッセージ定数クラス */
export class MsgConst {

    //#region 共通
    /** 共通 */
    static readonly COMMON = class {

        static readonly INFO_001 = '{0}を確認後、承認・否認ボタンを押してください。';
        static readonly INFO_002 = '{0}は上長の決裁待ちです。';
        static readonly INFO_003 = '承認済です。';
        static readonly INFO_004 = '締済です。更新できません。';
        static readonly INFO_005 = '{0}の申請登録が必要です。';
        static readonly INFO_006 = '{0}の登録または申請が必要です。';
        static readonly INFO_007 = '{0}は作成中です。';
        static readonly INFO_008 = '{0}は作成中です。登録完了後、勤務表から申請してください。';

        static readonly CONFIRM_001 = '{0}の登録・申請をしますか。';
        static readonly CONFIRM_002 = '{0}を申請しますか。';
        static readonly CONFIRM_003 = '{0}の申請を取り消しますか。';
        static readonly CONFIRM_004 = '{0}を確認しますか。';
        static readonly CONFIRM_005 = '{0}を承認しますか。';
        static readonly CONFIRM_006 = '{0}を否認しますか。※申請の否認はできません。';
        static readonly CONFIRM_007 = '{0}の締め処理を行いますか。';
        static readonly CONFIRM_008 = '{0}の締めを解除しますか。';
        static readonly CONFIRM_009 = '登録しますか。';
        static readonly CONFIRM_010 = '申請を取消しますか。';
        static readonly CONFIRM_011 = '{0}を取消しますか。';
        static readonly CONFIRM_012 = '確認しますか。';
        static readonly CONFIRM_013 = '承認しますか。';
        static readonly CONFIRM_014 = '否認しますか。';
        static readonly CONFIRM_015 = '{0}を否認しますか。';
        static readonly CONFIRM_016 = '{0}を選択してください。';
        static readonly CONFIRM_017 = '{0}を削除しますか。';
        static readonly CONFIRM_018 = '{0}を登録しますか。';


        static readonly ERROR_001 = '否認された内容があります。再登録してください。';
        static readonly ERROR_002 = '勤務表が登録されていないため、更新できません。';
        static readonly ERROR_003 = '勤務表が承認済です。更新できません。';
        static readonly ERROR_004 = '{0}に失敗しました。';
        static readonly ERROR_005 = '';
        static readonly ERROR_006 = '';
        static readonly ERROR_007 = '';
        static readonly ERROR_008 = '';
        static readonly ERROR_009 = '';
        static readonly ERROR_010 = '';
        static readonly ERROR_011 = '';
        static readonly ERROR_012 = '';
        static readonly ERROR_013 = '';
        static readonly ERROR_014 = '';
        static readonly ERROR_015 = '';
        static readonly ERROR_016 = '';
        static readonly ERROR_017 = '';
        static readonly ERROR_018 = '';
        static readonly ERROR_019 = '';
        static readonly ERROR_020 = '';

    }
    //#endregion

    //#region 駅探関連機能
    /** 駅探関連機能 */
    static readonly EKITAN = class {

        static readonly INFO_001 = '';

        static readonly CONFIRM_001 = '';

        static readonly ERROR_001 = 'APIリクエスト中にエラーが発生しました。時間をおいて再試行するか、システム管理者にお問い合わせください。';
        static readonly ERROR_002 = '{0}のため、検索結果を取得できませんでした。';
        static readonly ERROR_003 = '{0}の指定が正しくありません';
        static readonly ERROR_004 = '乗車駅と下車駅は空欄で検索できません';
        static readonly ERROR_005 = '該当列車・便無しのため、検索結果を取得できませんでした。';
        static readonly ERROR_006 = '';
        static readonly ERROR_007 = '';
        static readonly ERROR_008 = '';
        static readonly ERROR_009 = '';
        static readonly ERROR_010 = '';

    }
    //#endregion

    //#region 定期申請
    /** 定期申請 */
    static readonly TRAINPASS = class {

        static readonly INFO_001 = '前回定期購入の登録情報がありません。';
        static readonly INFO_002 = '前月の登録情報がありません。';

        static readonly CONFIRM_001 = '{0}は未選択または入力が不完全です。破棄して登録を続行しますか。';
        static readonly CONFIRM_002 = '定期を購入する場合、経路2と経路3の入力内容が破棄されます。よろしいですか。';
        static readonly CONFIRM_003 = '経路2と経路3の入力内容が破棄されます。よろしいですか。';
        static readonly CONFIRM_004 = '経路3の入力内容が破棄されます。よろしいですか。';
        static readonly CONFIRM_005 = '前月情報をコピーしますか。';
        static readonly CONFIRM_006 = '前月経路情報をコピーしますか。';
        static readonly CONFIRM_007 = '';
        static readonly CONFIRM_008 = '';
        static readonly CONFIRM_009 = '';
        static readonly CONFIRM_010 = '';

        static readonly ERROR_001 = '';

    }
    //#endregion

    //#region 勤務入力
    /** 勤務入力 */
    static readonly ATTENDANCE_ENTRY = class {
        static readonly INFO_001 = '勤務表ステータスが承認待ちのため操作できません。';

        static readonly CONFIRM_001 = '変更した時間項目が存在します。時間を上書きしますか。';
        static readonly CONFIRM_002 = '勤務時間を空欄にします。よろしいですか。';

        static readonly ERROR_001 = '申請が否認されました。申請を取り消し、再度登録してください。';
        static readonly ERROR_002 = '遅早退１・２で同じものが選択されています。';
        static readonly ERROR_003 = '遅刻と電車遅延は同時に申請できません。'
    }
    //#endregion

    //#region経費一覧
    /** 経費一覧 */
    static readonly COST_LIST = class {

        static readonly INFO_001 = '勤務表が登録されていないため、更新できません。';
        static readonly INFO_002 = '勤務表が承認済です。更新できません。';
        static readonly INFO_003 = '定期申請が未締です。更新できません。';
        static readonly INFO_004 = '';

        static readonly CONFIRM_001 = '領収書が添付されていない申請があります。このまま申請/承認しますか？対象日付：{0}';

        static readonly ERROR_001 = '経費一覧が差戻しされました。差戻し明細を修正し、再度申請を行ってください。';
        static readonly ERROR_002 = '勤務表が登録されていないため、更新できません。';
    }
    //#endregion

    //#region
    /** 経費明細 */
    static readonly COST_DETAIL = class {

        static readonly INFO_001 = '承認済みです。操作できません。';

        static readonly CONFIRM_001 = '前回交通費の検索条件を複写しますか。';
        static readonly CONFIRM_002 = '領収書が添付されていません。\r\nこのまま登録しますか。'

        static readonly ERROR_001 = '出発時刻が入力されていません。';
    }
    //#endregion

    //#region　勤務表
    /** 勤務表 */
    static readonly WORKING_LIST = class {


        static readonly ERROR_001 = '勤務表の締めは月間単位です。一覧表内の日付選択を解除してください。';
        static readonly ERROR_002 = '勤務表の締め解除は月間単位です。一覧表内の日付選択を解除してください。';
        static readonly ERROR_003 = '勤務表が差戻しされました。差戻し日を修正し、再度申請を行ってください。';
    }
    //#endregion
}
